export enum RoleType {
  Admin = 'ADMIN',
  Operator = 'OPERATOR',
  Superadmin = 'SUPER_ADMIN',
}
